import { useMediaQuery, useTheme } from "@mui/material";

export const useBreakpoint = () => {

    const theme = useTheme();

    const xs = useMediaQuery(theme.breakpoints.up('xs'));
    const sm = useMediaQuery(theme.breakpoints.up('sm'));
    const md = useMediaQuery(theme.breakpoints.up('md'));
    const lg = useMediaQuery(theme.breakpoints.up('lg'));
    const xl = useMediaQuery(theme.breakpoints.up('xl'));
    
    switch (true) {
        case xl: return 'xl'
        case lg: return 'lg'
        case md: return 'md'
        case sm: return 'sm'
        case xs: return 'xs'
        default: return 'xxs' 
    };

};